import { render, staticRenderFns } from "./Proyect.vue?vue&type=template&id=9586e954&"
import script from "./Proyect.vue?vue&type=script&lang=js&"
export * from "./Proyect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports